import { render, staticRenderFns } from "./CustomerLocationTypesComponent.vue?vue&type=template&id=dc991b2c"
import script from "./CustomerLocationTypesComponent.vue?vue&type=script&lang=js"
export * from "./CustomerLocationTypesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports